import type { ReactNode } from "react";

/**
 * A labelled row for a fact the host reports, following T3Code. The Summary is what the pull
 * request says: anything that acts on it lives in the panel's chrome beside the thing it acts
 * on — the title's own pencil, the lifecycle row, the composer that floats over the page —
 * rather than in sections of controls stacked underneath.
 */

export function PullRequestMetaRow({
  icon,
  label,
  children,
}: {
  readonly icon: ReactNode;
  readonly label: string;
  readonly children: ReactNode;
}) {
  return (
    <div className="grid min-w-0 grid-cols-[6rem_minmax(0,1fr)] items-center gap-2 text-xs">
      <span className="flex items-center gap-1.5 text-muted-foreground">
        {icon}
        {label}
      </span>
      <span className="min-w-0 text-foreground">{children}</span>
    </div>
  );
}
